import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { errMsg } from "../api";
import GoogleAuthButton from "../components/GoogleAuthButton";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const next = location.state?.next;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            const u = await login(email, password);
            navigate(next || (u.role === "admin" ? "/admin" : "/account"));
        } catch (e) {
            setErr(errMsg(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-5 py-20" data-testid="login-page">
            <div className="card-soft p-8">
                <h1 className="font-serif text-3xl mb-1">Welcome back</h1>
                <p className="text-[var(--muted)] text-sm mb-6">Sign in to continue your wellness journey.</p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="lbl">Email</label>
                        <input className="field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
                    </div>
                    <div>
                        <label className="lbl">Password</label>
                        <input className="field" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
                    </div>
                    {err && <div className="text-sm text-[var(--terra)]" data-testid="login-error">{err}</div>}
                    <button className="btn btn-primary w-full justify-center py-3" disabled={loading} data-testid="login-submit">
                        {loading ? "Signing in…" : "Sign in →"}
                    </button>
                </form>
                <GoogleAuthButton
                    onSuccess={(u) => navigate(next || (u.role === "admin" ? "/admin" : "/account"))}
                    onError={(m) => setErr(m)}
                />
                <div className="text-center text-sm mt-5 text-[var(--muted)]">
                    New to UCare? <Link to="/register" className="text-[var(--ink)] underline">Create an account</Link>
                </div>
                <div className="text-center text-[12px] mt-3 text-[var(--muted)]">
                    <Link to="/forgot-password" className="text-[var(--ink)] underline hover:text-[var(--taupe)]" data-testid="forgot-link">Forgot password?</Link>
                </div>
                <div className="text-center text-[12px] mt-6 text-[var(--muted)]">
                    <Link to="/admin/login" className="hover:text-[var(--ink)]">Admin sign in →</Link>
                </div>
            </div>
        </div>
    );
}
